import Vue from 'vue'
import numeral from 'numeral'

Vue.filter('numberFormat', function (value) {
  return numeral(value)
    .format('0,0')
})

Vue.filter('modelSingular', function (model) {
  const modelMap = {
    accounts: 'account',
    roles: 'role',
    account_properties: 'property',
    account_invites: 'invite',
    properties: 'property',
    companies: 'company',
    subscriptions: 'subscription'
  }

  if (modelMap.hasOwnProperty(model)) {
    return modelMap[model]
  }

  return model
})

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})



// WEBPACK FOOTER //
// ./src/lib/Filters.js